/*
 * PARTPOINT — search-enhance.js · v2.0.0 (2026-09-24, OPUS search audit S2/S4/S5/S7/S8)
 *
 * Every search box on the site (header, mobile menu, hero, 404, /search) gets the same suggestions from the same
 * engine as the /search page (assets/pp-search-core.js over the complete published catalog, section
 * pp-search-index). The engine is loaded only when a visitor shows intent (focus / pointer / typing), so other
 * pages keep their LCP/INP. When the engine cannot run (old browser, index not complete, network) the popup falls
 * back to Shopify's own search section, exactly as before.
 *
 * Kept on purpose: window.PartpointSearch.normalize (pp-model-menu.js filters its model grid with it), the popup
 * markup/classes (pp-header-search.css), the mobile-menu helpers at the bottom.
 * Changed on purpose: the query is no longer rewritten on submit — the customer's own words stay in the URL, and
 * the /search page reads them with the same engine (a shared link gives the same result as the form).
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- legacy alias normalizer (model menu) */
  const aliases = {
    'ჰიუნდაი': 'Hyundai', 'ჰუნდაი': 'Hyundai', 'ჰუნდეი': 'Hyundai', 'ჰიუნდეი': 'Hyundai', 'хундай': 'Hyundai', 'хёндай': 'Hyundai', 'хёндэ': 'Hyundai', 'хюндай': 'Hyundai',
    'კია': 'KIA', 'киа': 'KIA', 'кия': 'KIA',
    'ტუსკონი': 'Tucson', 'ტუქსონი': 'Tucson', 'туксон': 'Tucson', 'тусон': 'Tucson', 'ტუსონი': 'Tucson', 'ტუკსონი': 'Tucson', 'ტუქსონ': 'Tucson', 'ტუსონ': 'Tucson', 'ტუსკონ': 'Tucson',
    'ტიუკსონი': 'Tucson', 'ტუქსონნი': 'Tucson', 'туссан': 'Tucson', 'туссанн': 'Tucson', 'ტუსანი': 'Tucson',
    'სონატა': 'Sonata', 'соната': 'Sonata', 'ელანტრა': 'Elantra', 'элантра': 'Elantra',
    'სანტაფე': 'Santa Fe', 'სანტა ფე': 'Santa Fe', 'სანტა-ფე': 'Santa Fe', 'санта фе': 'Santa Fe', 'сантафе': 'Santa Fe', 'санта-фе': 'Santa Fe',
    'კონა': 'Kona', 'кона': 'Kona', 'პალისადი': 'Palisade', 'პალისეიდი': 'Palisade', 'палисад': 'Palisade', 'палисейд': 'Palisade',
    'აქცენტი': 'Accent', 'акцент': 'Accent', 'ი30': 'i30', 'и30': 'i30', 'ი20': 'i20', 'и20': 'i20', 'ველოსტერი': 'Veloster', 'велостер': 'Veloster',
    'ჯენესისი': 'Genesis', 'генезис': 'Genesis', 'აზერა': 'Azera', 'азера': 'Azera', 'ვერაკრუსი': 'Veracruz', 'веракруз': 'Veracruz',
    'სპორტეიჯი': 'Sportage', 'სპორტაჟი': 'Sportage', 'სპორტაჯი': 'Sportage', 'спортейдж': 'Sportage', 'спортидж': 'Sportage', 'спортедж': 'Sportage',
    'სელტოსი': 'Seltos', 'селтос': 'Seltos', 'სორენტო': 'Sorento', 'соренто': 'Sorento', 'ფორტე': 'Forte', 'форте': 'Forte', 'ნირო': 'Niro', 'ниро': 'Niro',
    'ოპტიმა': 'Optima', 'оптима': 'Optima', 'რიო': 'Rio', 'рио': 'Rio', 'სედონა': 'Sedona', 'седона': 'Sedona', 'პიკანტო': 'Picanto', 'пиканто': 'Picanto',
    'სტინგერი': 'Stinger', 'стингер': 'Stinger', 'ცერატო': 'Cerato', 'церато': 'Cerato', 'სოული': 'Soul', 'соул': 'Soul', 'ტელურიდი': 'Telluride', 'теллурайд': 'Telluride',
    'კარნივალი': 'Carnival', 'карнавал': 'Carnival', 'სანტა კრუზი': 'Santa Cruz', 'სანტაკრუზი': 'Santa Cruz', 'санта круз': 'Santa Cruz', 'ვენიუ': 'Venue', 'веню': 'Venue',
    'კ4': 'K4', 'კ5': 'K5', 'к4': 'K4', 'к5': 'K5', 'ჰიუნდაიი': 'Hyundai', 'ჰიონდაი': 'Hyundai'
  };
  const modelNames = new Set(Object.values(aliases).filter(value => /^[A-Za-z0-9 ]+$/.test(value)));
  modelNames.forEach(value => { aliases[value.toLowerCase()] = value; });
  const phraseKeys = Object.keys(aliases).filter(key => key.includes(' ')).sort((a, b) => b.length - a.length);
  function oneEdit(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    if (a.length === b.length) {
      const diff = [];
      for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) diff.push(i);
      if (diff.length === 1) return true;
      return diff.length === 2 && diff[1] === diff[0] + 1 && a[diff[0]] === b[diff[1]] && a[diff[1]] === b[diff[0]];
    }
    const shorter = a.length < b.length ? a : b, longer = a.length < b.length ? b : a;
    let i = 0, j = 0;
    while (i < shorter.length && j < longer.length) { if (shorter[i] === longer[j]) { i++; j++; } else { j++; if (j - i > 1) return false; } }
    return true;
  }
  /** Latinizes model names („ტუსანი“ → Tucson). Used by the model menu filter only. */
  function normalize(original, expandPrefix = false, locale = 'ka') {
    const words = String(original || '').normalize('NFC').trim().split(/[\s,.;:!?()"'«»„“]+/u).filter(Boolean);
    const output = [];
    for (let i = 0; i < words.length; i++) {
      const phrase = phraseKeys.find(key => words.slice(i, i + key.split(' ').length).join(' ').toLowerCase() === key);
      if (phrase) { output.push(aliases[phrase]); i += phrase.split(' ').length - 1; continue; }
      const word = words[i], lower = word.toLowerCase();
      if (aliases[lower]) { output.push(locale === 'ru' && !modelNames.has(aliases[lower]) ? word : aliases[lower]); continue; }
      if (!/^\p{L}+$/u.test(word)) { output.push(word); continue; }
      const candidates = new Set();
      Object.keys(aliases).forEach(key => {
        if (!modelNames.has(aliases[key]) || key.includes(' ')) return;
        if (lower.length >= 5 && oneEdit(lower, key)) candidates.add(aliases[key]);
      });
      if (candidates.size === 0 && expandPrefix && i === words.length - 1 && lower.length >= 3) {
        Object.keys(aliases).forEach(key => { if (modelNames.has(aliases[key]) && key.startsWith(lower)) candidates.add(aliases[key]); });
      }
      output.push(candidates.size === 1 ? [...candidates][0] : word);
    }
    return output.join(' ');
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { normalize, oneEdit }; return; }

  /* ---------------------------------------------------------------- engine loader (shared with /search) */
  const MAX_QUERY = 200;
  let corePromise = null;
  function coreUrl() {
    const node = document.getElementById('pp-search-config');
    if (node) { try { const cfg = JSON.parse(node.textContent); if (cfg && typeof cfg.core === 'string') return cfg.core; } catch (e) { /* ignore */ } }
    const tag = document.querySelector('script[data-pp-search-core]');
    return tag ? tag.src : null;
  }
  /** Resolves with PPSearchCore (supported or not); never loads it twice. */
  function ensureCore() {
    if (window.PPSearchCore) return Promise.resolve(window.PPSearchCore);
    if (corePromise) return corePromise;
    corePromise = new Promise((resolve, reject) => {
      const done = () => (window.PPSearchCore ? resolve(window.PPSearchCore) : reject(new Error('core missing')));
      const existing = document.querySelector('script[data-pp-search-core]');
      if (existing) {
        existing.addEventListener('load', done, { once: true });
        existing.addEventListener('error', () => reject(new Error('core failed')), { once: true });
        return;
      }
      const src = coreUrl();
      if (!src || !/^(?:https?:)?\/\//.test(src) && !src.startsWith('/')) { reject(new Error('no core url')); return; }
      const script = document.createElement('script');
      script.src = src; script.async = true; script.dataset.ppSearchCore = '1';
      script.addEventListener('load', done, { once: true });
      script.addEventListener('error', () => reject(new Error('core failed')), { once: true });
      document.head.appendChild(script);
    }).catch(err => { corePromise = null; throw err; });
    return corePromise;
  }
  /** The complete catalog index (cached 5 min in localStorage by the core); rejects when it cannot be complete. */
  function ensureIndex() {
    return ensureCore().then(core => {
      if (!core.supported) throw new Error('engine unsupported');
      return core.loadIndex().then(index => ({ core, index }));
    });
  }
  window.PPSearch = Object.freeze({ ensureCore, ensureIndex });
  window.PartpointSearch = Object.freeze({ normalize, ensureIndex });

  /* ---------------------------------------------------------------- suggestions popup */
  const labelsNode = document.getElementById('pp-search-labels');
  let labels = { suggestions: 'Suggestions', view_all: 'View all results', no_results: 'No products found.', unavailable: 'Suggestions are unavailable.', searching: 'Searching…', normalized: '__QUERY__' };
  if (labelsNode) { try { labels = Object.assign(labels, JSON.parse(labelsNode.textContent)); } catch (e) { /* keep defaults */ } }
  const lang = (document.documentElement.lang || 'ka').split('-')[0].toLowerCase();
  const nativeCache = new Map();
  let nextId = 0;
  let engine = null; // { core, index } once loaded

  function warm() {
    if (engine) return Promise.resolve(engine);
    return ensureIndex().then(e => { engine = e; return e; });
  }
  function el(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  class SmartSearch {
    constructor(form, input) {
      this.form = form; this.input = input; this.version = 0; this.active = -1; this.options = []; this.composing = false;
      this.popup = document.createElement('div'); this.popup.className = 'pp-search-popup'; this.popup.hidden = true;
      this.topLayer = typeof this.popup.showPopover === 'function';
      if (this.topLayer) this.popup.setAttribute('popover', 'manual');
      this.status = el('p', 'pp-search-status'); this.status.setAttribute('role', 'status'); this.status.setAttribute('aria-live', 'polite');
      this.list = el('div', 'pp-search-list'); this.list.id = 'pp-search-list-' + (++nextId); this.list.setAttribute('role', 'listbox'); this.list.setAttribute('aria-label', labels.suggestions);
      this.popup.append(this.status, this.list); form.append(this.popup);
      input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list'); input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-controls', this.list.id); input.setAttribute('autocomplete', 'off');
      input.removeAttribute('aria-owns'); input.removeAttribute('aria-haspopup');
      if (!input.maxLength || input.maxLength < 0 || input.maxLength > MAX_QUERY) input.maxLength = MAX_QUERY;
      if (!input.getAttribute('aria-label') && !(input.labels && input.labels.length)) input.setAttribute('aria-label', input.placeholder || labels.suggestions);
      // S5: every public search asks for products only — the same set the counts and pagination describe
      if (!form.querySelector('input[name="type"]')) { const t = document.createElement('input'); t.type = 'hidden'; t.name = 'type'; t.value = 'product'; form.append(t); }
      this.onViewport = () => { if (!this.raf) this.raf = requestAnimationFrame(() => { this.raf = 0; this.position(); }); };
      input.addEventListener('input', event => { if (!event.isComposing && !this.composing) this.schedule(); });
      input.addEventListener('compositionstart', () => { this.composing = true; });
      input.addEventListener('compositionend', () => { this.composing = false; this.schedule(); });
      input.addEventListener('focus', () => { warm().catch(() => {}); if (input.value.trim().length >= 2) this.schedule(); });
      input.addEventListener('pointerenter', () => { warm().catch(() => {}); }, { once: true });
      input.addEventListener('keydown', event => this.keydown(event));
      form.addEventListener('reset', () => this.cancel());
      form.addEventListener('submit', () => { this.cancel(); }, true);
      form.addEventListener('focusout', () => { setTimeout(() => { if (!form.contains(document.activeElement)) this.cancel(); }, 0); });
      document.addEventListener('pointerdown', event => { if (!form.contains(event.target)) this.cancel(); });
      this.popup.addEventListener('pointermove', event => { const option = event.target.closest('[role="option"]'); if (option) this.select(this.options.indexOf(option), false); });
      const menu = form.closest('details'); if (menu) menu.addEventListener('toggle', () => { if (!menu.open) this.cancel(); });
    }
    url(term, section) {
      const url = new URL(this.form.getAttribute('action') || '/search', window.location.origin);
      url.searchParams.set('q', term); url.searchParams.set('type', 'product'); url.searchParams.set('options[prefix]', 'last');
      const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
      if (previewId && /^\d{1,20}$/.test(previewId)) url.searchParams.set('preview_theme_id', previewId);
      if (section) url.searchParams.set('section_id', 'pp-search-suggestions');
      return url;
    }
    schedule() {
      this.cancel(false);
      const value = this.input.value;
      if (value.trim().length < 2 || value.length > MAX_QUERY) { this.close(); return; }
      const version = this.version;
      this.timer = setTimeout(() => this.fetchResults(version), engine ? 120 : 280);
    }
    cancel(close = true) {
      clearTimeout(this.timer); if (this.controller) this.controller.abort(); this.version++;
      if (close) this.close();
    }
    close() {
      if (this.topLayer && this.popup.matches(':popover-open')) this.popup.hidePopover();
      this.popup.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.input.removeAttribute('aria-activedescendant'); this.active = -1;
      this.listen(false);
    }
    open() {
      if (document.activeElement !== this.input) return;
      this.popup.hidden = false;
      if (this.topLayer && !this.popup.matches(':popover-open')) this.popup.showPopover();
      this.input.setAttribute('aria-expanded', 'true'); this.position(); this.listen(true);
    }
    /** S8: the soft keyboard changes the visual viewport, not the window — follow both while open, drop them when closed. */
    listen(on) {
      if (on === this.listening) return;
      this.listening = on;
      const method = on ? 'addEventListener' : 'removeEventListener';
      window[method]('resize', this.onViewport, { passive: true });
      window[method]('scroll', this.onViewport, { passive: true });
      if (window.visualViewport) { window.visualViewport[method]('resize', this.onViewport, { passive: true }); window.visualViewport[method]('scroll', this.onViewport, { passive: true }); }
    }
    position() {
      if (this.popup.hidden) return;
      const anchor = this.input.closest('.field') || this.input.closest('.ppxh-search, .pp-404__search, .pp-menu-search') || this.form;
      const rect = anchor.getBoundingClientRect();
      const viewport = window.visualViewport;
      const top0 = viewport ? viewport.offsetTop : 0, height = viewport ? viewport.height : window.innerHeight, width0 = viewport ? viewport.width : window.innerWidth, left0 = viewport ? viewport.offsetLeft : 0;
      if (rect.bottom < top0 || rect.top > top0 + height || rect.width === 0) { this.cancel(); return; }
      const width = Math.min(Math.max(rect.width, 280), width0 - 24);
      this.popup.style.width = width + 'px';
      this.popup.style.left = Math.max(left0 + 12, Math.min(rect.left, left0 + width0 - width - 12)) + 'px';
      const below = top0 + height - rect.bottom - 12, above = rect.top - top0 - 12;
      if (below < 160 && above > below) {
        const h = Math.min(420, above);
        this.popup.style.maxHeight = h + 'px';
        this.popup.style.top = Math.max(top0 + 8, rect.top - Math.min(this.popup.scrollHeight, h) - 6) + 'px';
      } else {
        this.popup.style.top = rect.bottom + 6 + 'px';
        this.popup.style.maxHeight = Math.max(100, Math.min(440, below)) + 'px';
      }
    }
    async fetchResults(version) {
      const raw = this.input.value.trim().slice(0, MAX_QUERY);
      this.options = []; this.list.replaceChildren(); this.status.textContent = labels.searching; this.open();
      let ready = engine;
      if (!ready) {
        // wait briefly for the engine; Shopify's own search answers this keystroke if it is not there yet
        ready = await Promise.race([warm().catch(() => null), new Promise(resolve => setTimeout(() => resolve(null), 1200))]);
      }
      if (version !== this.version || !this.form.isConnected) return;
      if (ready) this.renderEngine(ready, raw);
      else await this.renderNative(version, raw);
    }
    renderEngine(e, raw) {
      const { core, index } = e;
      const result = core.search(index, raw, {});
      const items = result.main.slice(0, 6);
      // nothing sure: the other-quality variants (when a quality was asked) or the „to be confirmed“ ones, marked as such
      const extra = items.length ? [] : (result.quality.length ? result.quality.slice(0, 4) : result.unknown.slice(0, 3));
      const frag = document.createDocumentFragment();
      items.concat(extra).forEach(item => frag.append(this.option(core, index, item, extra.includes(item) && !result.quality.length)));
      this.list.replaceChildren(frag);
      const understood = core.describeIntent(result.intent, lang).map(c => c.label).join(' · ');
      const note = result.notes.find(n => !/^(?:sku_exact|sku_prefix|clarify|model_corrected|term_corrected|term_ignored)$/.test(n.code));
      let status;
      if (items.length) status = understood && result.mode !== 'sku' ? core.msg(lang, 'understood') + ' ' + understood : labels.suggestions;
      else if (note) status = core.msg(lang, note.code, noteParams(core, note));
      else if (result.mode === 'clarify') status = core.msg(lang, 'clarifyShort');
      else status = extra.length ? core.msg(lang, 'unknownTitle', { n: result.unknown.length }) : core.msg(lang, 'suggestNone');
      this.status.textContent = status;
      const total = result.mode === 'clarify' ? 0 : result.total;
      const all = el('a', 'pp-search-option pp-search-all', total > items.length ? core.msg(lang, 'viewAll', { n: total }) : labels.view_all);
      all.href = this.url(raw).href;
      this.list.append(all);
      this.finishOptions();
    }
    option(core, index, item, unconfirmed) {
      const a = el('a', 'pp-search-option');
      a.href = core.productUrl(item, index.localeRoot);
      a.dataset.ppSearchItem = '';
      const src = core.imageUrl(item, 104);
      if (src) { const img = document.createElement('img'); img.src = src; img.width = 52; img.height = 52; img.alt = ''; img.loading = 'lazy'; img.decoding = 'async'; a.append(img); }
      const text = el('span', null, item.title);
      const meta = [core.formatMoney(item.price, index.money)];
      if (!item.available) meta.push(core.msg(lang, 'soldOut'));
      if (unconfirmed) meta.push(core.msg(lang, 'toConfirm'));
      text.append(el('small', null, meta.filter(Boolean).join(' · ')));
      a.append(text);
      return a;
    }
    async renderNative(version, raw) {
      const url = this.url(raw, true);
      this.controller = new AbortController();
      const controller = this.controller;
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        let html = nativeCache.get(url.href);
        if (!html) {
          const response = await fetch(url, { signal: controller.signal, credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
          if (!response.ok) throw Error('Search unavailable');
          html = await response.text();
        }
        if (version !== this.version || !this.form.isConnected) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const results = parsed.querySelector('[data-pp-search-results]');
        if (!results) throw Error('Invalid search section');
        if (!nativeCache.has(url.href)) { if (nativeCache.size >= 30) nativeCache.delete(nativeCache.keys().next().value); nativeCache.set(url.href, html); }
        const items = [...results.querySelectorAll('a[data-pp-search-item]')].filter(a => {
          try { return new URL(a.getAttribute('href'), location.origin).origin === location.origin; } catch (e) { return false; }
        });
        this.list.replaceChildren(...items);
        this.status.textContent = items.length ? labels.suggestions : labels.no_results;
        const all = el('a', 'pp-search-option pp-search-all', labels.view_all); all.href = this.url(raw).href; this.list.append(all);
        this.finishOptions();
      } catch (error) {
        if (version !== this.version) return;
        this.list.replaceChildren(); this.options = []; this.status.textContent = labels.unavailable; this.open();
      } finally { clearTimeout(timeout); }
    }
    finishOptions() {
      this.options = [...this.list.querySelectorAll('a')];
      this.options.forEach((option, index) => { option.id = this.list.id + '-' + index; option.setAttribute('role', 'option'); option.setAttribute('aria-selected', 'false'); option.setAttribute('tabindex', '-1'); });
      this.active = -1; this.input.removeAttribute('aria-activedescendant');
      this.open();
    }
    select(index, scroll = true) {
      this.active = index;
      this.options.forEach((option, i) => option.setAttribute('aria-selected', String(i === index)));
      const option = this.options[index];
      if (option) { this.input.setAttribute('aria-activedescendant', option.id); if (scroll) option.scrollIntoView({ block: 'nearest' }); }
      else this.input.removeAttribute('aria-activedescendant');
    }
    keydown(event) {
      if (event.isComposing || this.composing) return;
      if (event.key === 'Escape' && !this.popup.hidden) { event.preventDefault(); event.stopPropagation(); this.cancel(); return; }
      if (this.popup.hidden) {
        if (event.key === 'ArrowDown' && this.input.value.trim().length >= 2) { event.preventDefault(); this.schedule(); }
        return;
      }
      const n = this.options.length;
      if ((event.key === 'ArrowDown' || event.key === 'ArrowUp') && n) {
        event.preventDefault();
        // S7: from the input the first ArrowDown selects the first option and the first ArrowUp the LAST one
        let next;
        if (this.active < 0) next = event.key === 'ArrowDown' ? 0 : n - 1;
        else next = (this.active + (event.key === 'ArrowDown' ? 1 : -1) + n) % n;
        this.select(next);
        return;
      }
      if (event.key === 'Enter' && this.active >= 0 && this.options[this.active]) { event.preventDefault(); this.options[this.active].click(); return; }
      if (event.key === 'Tab') this.cancel();
    }
  }
  function noteParams(core, note) {
    const p = Object.assign({}, note);
    if (note.quality) p.quality = core.msg(lang, note.quality);
    return p;
  }

  function scan() {
    document.querySelectorAll('form[action*="/search"]').forEach(form => {
      const input = form.querySelector('input[name="q"]:not([type="hidden"])');
      if (!input || form.dataset.ppEnhanced) return;
      form.dataset.ppEnhanced = '1'; new SmartSearch(form, input);
    });
    document.querySelectorAll('.pp-mobile-menu:not([data-pp-menu])').forEach(menu => {
      menu.dataset.ppMenu = '1';
      menu.addEventListener('keydown', event => { if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
      document.addEventListener('pointerdown', event => { if (menu.open && !menu.contains(event.target)) menu.open = false; });
      menu.addEventListener('focusout', () => setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 0));
      window.addEventListener('resize', () => { if (window.innerWidth >= 990) menu.open = false; }, { passive: true });
    });
    // intent to search (opening the header search or the menu) warms the engine before the first keystroke
    document.querySelectorAll('.header__icon--search, .pp-mobile-menu > summary').forEach(node => {
      if (node.dataset.ppWarm) return;
      node.dataset.ppWarm = '1';
      node.addEventListener('pointerdown', () => { warm().catch(() => {}); }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);
})();
